import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Target, Heart, Award } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { mockData } from '../mock';

const About = () => {
  const valueIcons = {
    Excellence: Award,
    Fiabilité: Target,
    Confort: Heart
  };

  return (
    <div className="min-h-screen bg-slate-950 pt-20">
      {/* Hero Section */}
      <section className="py-24 bg-gradient-to-b from-slate-900 to-slate-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            À Propos
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Votre partenaire de confiance pour tous vos déplacements sur la Côte d'Azur
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-24">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-6">
              {mockData.about.title}
            </h2>
            <p className="text-gray-300 text-lg leading-relaxed mb-8">
              {mockData.about.description}
            </p>
            <p className="text-gray-400 text-lg leading-relaxed">
              {mockData.about.mission}
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-24 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">
              Nos Valeurs
            </h2>
            <p className="text-gray-400 text-lg">
              Ce qui guide chacune de nos actions
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {mockData.about.values.map((value) => {
              const IconComponent = valueIcons[value.title];
              return (
                <Card key={value.title} className="bg-slate-950 border-slate-800 hover:border-amber-600/50 transition-all duration-300 group">
                  <CardContent className="p-8 text-center space-y-4">
                    <div className="w-16 h-16 bg-amber-600/10 rounded-full flex items-center justify-center mx-auto group-hover:bg-amber-600/20 transition-colors duration-300">
                      {IconComponent && <IconComponent className="w-8 h-8 text-amber-500" />}
                    </div>
                    <h3 className="text-2xl font-bold text-white">{value.title}</h3>
                    <p className="text-gray-400 leading-relaxed">{value.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Commitment Section */}
      <section className="py-24">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card className="bg-slate-900 border-slate-800">
            <CardContent className="p-12">
              <div className="text-center space-y-6">
                <div className="inline-block px-6 py-2 bg-amber-600/10 border border-amber-600/30 rounded-full">
                  <span className="text-amber-500 font-medium">Notre Engagement</span>
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-white">
                  Un Service d'Excellence
                </h2>
                <p className="text-gray-300 text-lg leading-relaxed max-w-3xl mx-auto">
                  Chez AzurDriver Pro, nous nous engageons à vous offrir bien plus qu'un simple transport. 
                  Chaque trajet est une expérience pensée pour votre confort et votre satisfaction. 
                  Notre équipe de chauffeurs professionnels est formée pour répondre aux plus hautes 
                  exigences de service.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pt-8">
                  <div className="text-center">
                    <div className="text-4xl font-bold text-amber-500 mb-2">100%</div>
                    <p className="text-gray-400">Satisfaction Client</p>
                  </div>
                  <div className="text-center">
                    <div className="text-4xl font-bold text-amber-500 mb-2">24/7</div>
                    <p className="text-gray-400">Service Disponible</p>
                  </div>
                  <div className="text-center">
                    <div className="text-4xl font-bold text-amber-500 mb-2">+5 ans</div>
                    <p className="text-gray-400">D'Expérience</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-slate-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Prêt à Vivre l'Expérience AzurDriver Pro ?
          </h2>
          <p className="text-gray-400 text-lg mb-8">
            Réservez dès maintenant votre prochain trajet
          </p>
          <Link to="/contact">
            <Button className="bg-amber-600 hover:bg-amber-700 text-white text-lg px-8 py-6 transition-all duration-300 hover:shadow-lg hover:shadow-amber-600/50">
              <Phone className="w-5 h-5 mr-2" />
              Nous Contacter
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
